import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-resources-dashboard',
  templateUrl: './resources-dashboard.component.html',
  styleUrls: ['./resources-dashboard.component.scss']
})
export class ResourcesDashboardComponent implements OnInit {
  leadsId: any;
  agentId: string;
  leadStatus: any;

  constructor(public router: Router,public user: UserService) { }
  hideQuotePurchase:any;
  checkOVRInAgencyCode: any;
  agentIdActive: string;
  ngOnInit(): void {
    this.leadsId=sessionStorage.getItem('leadId');
    this.agentId=sessionStorage.getItem('agentIdSalesPortal');
    this.getLeadAgentsCodes();
    this.hideQuotePurchase=sessionStorage.getItem('hideQuotePurchase');
    this.checkOVRInAgencyCode=sessionStorage.getItem('checkOVRInAgencyCode');
    this.getDashboard();
  }
  isDisabled: boolean = false;
  goToQuotePurchase(){
    if(this.isDisabled){
      return;
    }
    if(this.hideQuotePurchase!="true" && this.agentIdActive=='true'){
      this.router.navigateByUrl('/dashboard/Quotes-Purchase');
    }else{
      if(this.hideQuotePurchase=="true"){
      Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
    }
  }
  getLeadAgentsCodes(){
    this.user.getLeadAgentsCodes(this.leadsId).pipe()
    .subscribe(
      data => {
      // console.log(data);
      // this.agentcodedata=[];
    ////
      // this.agentIdActive=sessionStorage.getItem('agentIdActive');
      for(let i=0;i<data.data.agentCodes.length;i++){
        if(this.agentId==data.data.agentCodes[i].id){
          if(data.data.agentCodes[i].status=="Active" || data.data.agentCodes[i].status=="Primary")
          {
          this.agentIdActive='true'
          }
          else{
            this.agentIdActive='false'
          }
        }
       // this.agentcodedata.push(data.data.agentCodes[i])
        // console.log(this.agentcodedata)
      }
      }, error => {
  
        // if (error.status == 400 || error.status == 417) {
        //   this.error = error.error.data;
        // }
        // else {
        //   this.error = "Something went wrong. Please check username and password.";
        // }
      }, () => { });
    }
   
      goToSalesHome(){
        if(this.agentIdActive=='true'){
          this.router.navigateByUrl('/dashboard/sales-home');
        }else{
          // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
        }
  
      }
  goToPolicySearch(){
    if(this.agentIdActive=='true'){
      this.router.navigateByUrl('/dashboard/policy-search');
    }else{
      // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
  
  }
  goToSaveQuote(){
    
    if(this.agentIdActive=='true'){
      this.router.navigateByUrl('/dashboard/Save-Quotes');
    }else{
      // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
  }
  goToforms(){
    
    if(this.agentIdActive=='true'){
      this.router.navigateByUrl('/dashboard/forms');
    }else{
      // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
  }
  goToResources(){
    if(this.agentIdActive=='true'){
      this.router.navigateByUrl('/dashboard/resources');
    }else{
      // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
  
  }
  getDashboard() {
    this.user.getDashboardData().pipe()
      .subscribe(
        data => {
          this.leadStatus=data.data.leads.leadStatus;
          if(this.leadStatus == 'Deactivated'){
            this.isDisabled = true;
          } else{
            this.isDisabled = false;
          }
         }, error => {
        }, () => { });
  }
  }
